import { FinanceModel } from '../api/contracts/financemodels';

export type GroupedFinanceModelsByCategoriesAndManufacturers = {
  [categoryName: string]: {
    [manufacturerName: string]: FinanceModel[];
  };
};

export const useGroupModelsByCategoryAndManufacturer = (
  items: FinanceModel[]
): GroupedFinanceModelsByCategoriesAndManufacturers => {
  const groupedItems: GroupedFinanceModelsByCategoriesAndManufacturers = {};

  items.forEach(item => {
    const { category, manufacturer } = item;

    const categoryName = category.name;
    const manufacturerName = manufacturer.name;

    if (!groupedItems[categoryName]) {
      groupedItems[categoryName] = {};
    }

    if (!groupedItems[categoryName][manufacturerName]) {
      groupedItems[categoryName][manufacturerName] = [];
    }

    groupedItems[categoryName][manufacturerName].push(item);
  });

  return groupedItems;
};
